import { createActions } from 'redux-actions';

export const {
  getTemplateById,
  getTemplateByIdSuccess,
  getTemplateByIdFailure,
  createTemplate,
  createTemplateSuccess,
  createTemplateError,
  updateTemplate,
  updateTemplateSuccess,
  updateTemplateError,
  deleteTemplate,
  deleteTemplateSuccess,
  deleteTemplateError,
} = createActions(
  'GET_TEMPLATE_BY_ID',
  'GET_TEMPLATE_BY_ID_SUCCESS',
  'GET_TEMPLATE_BY_ID_FAILURE',
  'CREATE_TEMPLATE',
  'CREATE_TEMPLATE_SUCCESS',
  'CREATE_TEMPLATE_ERROR',
  'UPDATE_TEMPLATE',
  'UPDATE_TEMPLATE_SUCCESS',
  'UPDATE_TEMPLATE_ERROR',
  'DELETE_TEMPLATE',
  'DELETE_TEMPLATE_SUCCESS',
  'DELETE_TEMPLATE_ERROR'
);
